module.exports = __webpack_public_path__ + "static/media/face-fill@2x.0a405d6d.svg";